/**
 * Environment configuration for the application
 */
export const environment = {
  production: true,
  apiBaseUrl: '', // Backend API URL
  version: '1.0.0',
  defaultLanguage: 'en',
  supportedLanguages: ['en', 'fr', 'ar'],
  defaultCurrency: 'TND',
  defaultPageSize: 10,
  maxPageSize: 350,
  dateFormat: 'yyyy-MM-dd',
  timeFormat: 'HH:mm',
  dateTimeFormat: 'yyyy-MM-dd HH:mm',

  // Feature flags
  features: {
    enableSmsNotifications: false,
    enableEmailNotifications: true,
    enablePaymentReceipts: true,
    enableExportFeatures: true,
    enableDarkMode: false
  }
};
